import { StateBox } from './HSM.tsx';
import type { StateBoxProps } from '.HSM.tsx';
import react, { useEffect, useState } from 'react';
import React from 'react';
import { CommentProps, PaperProps } from './HSM';
import { CommentsSidebar, CommentsSidebarProps } from './Sidebar.tsx';
import { act } from '@testing-library/react';
import { PapersSidebar, PapersSidebarProps } from './Sidebar.tsx';
import { useParams, useSearchParams } from 'react-router-dom';
import leftArrow from './imgs/arrow-left.png';
import rightArrow from './imgs/arrow.png';
import downArrow from './imgs/arrow-down.png';
import { UserContext } from './App';
import {
  getNewStateProps,
  addState,
  addStateUid,
  getStatesCurrentLayer,
  getStateTypeFromLayers,
  updatePropertyOfState,
  deleteState,
  getPropsOfState,
  addComment,
  addPaper,
} from './utils/stateUtils.tsx';
import {
  crumbsToUids,
  updateTitleOfActivity,
  getIndexOfState,
  deleteStateUid,
} from './utils/stateUtils.tsx';

enum TRANSITION_TYPE {
  BEFORE,
  BETWEEN,
  AFTER,
}

enum TRANSITION_ORIENTATION {
  LEFT = 'arrow-left.png',
  RIGHT = 'arrow.png',
  DOWN = 'arrow-down.png',
}

type BCNavProps = {
  crumbIds: number[];
  setCrumbIds: React.Dispatch<React.SetStateAction<number[]>>;
  setLayer: React.Dispatch<React.SetStateAction<string>>;
  activityProps: StateBoxProps;
  onMouseEnterCrumb: () => void;
  onMouseLeaveCrumb: () => void;
};

const BCNav = ({
  crumbIds,
  setCrumbIds,
  setLayer,
  activityProps,
  onMouseEnterCrumb,
  onMouseLeaveCrumb,
}: BCNavProps) => {
  function onClickActivities() {
    window.open(
      'http://sparcs-box-342816.uk.r.appspot.com/adls/' + activityProps.avatar,
      '_self'
    );
  }

  const crumbElts: any[] = [
    <a
      className='bcLink'
      onMouseEnter={onMouseEnterCrumb}
      onMouseLeave={onMouseLeaveCrumb}
      onClick={onClickActivities}
    >
      Activities
    </a>,
  ];
  let currentProps = activityProps;

  for (let i = 0; i < crumbIds.length; i++) {
    // initialize the prop for the anchor for this crumb
    const lastCrumb = i === crumbIds.length - 1;
    let anchorProps: any = {
      key: i,
      onMouseEnter: onMouseEnterCrumb,
      onMouseLeave: onMouseLeaveCrumb,
      onClick: () => {
        setCrumbIds((prevCrumbs) => prevCrumbs.slice(0, i + 1));
        setLayer(i.toString());
      },
    };

    if (lastCrumb) {
      // the last breadcrumb is styled differently
      anchorProps = { ...anchorProps, className: 'activeBreadCrumb' };
    }

    crumbElts.push(' > ');
    crumbElts.push(
      <a className='bcLink' {...anchorProps}>
        {currentProps.text}
      </a>
    );

    if (!lastCrumb) {
      // currentProps = currentProps.children[crumbIds[i+1]];
      for (let j = 0; j < currentProps.children.length; j++) {
        if (currentProps.children[j].id === crumbIds[i + 1]) {
          currentProps = currentProps.children[j];
        }
      }
    }
  }

  return <div className='breadCrumbNav'>{crumbElts}</div>;
};

export type HSMContainerProps = {
  stateAncestors: object[];
  level: number;
  hsm: React.ReactElement<HSMViewProps>;
};

export const HSMContainer = ({
  stateAncestors,
  level,
  hsm,
}: HSMContainerProps) => {
  const arrowImg = <img width={30} height={15} src={rightArrow} />;
  let containerClassName;
  let nextContainerClassName;
  let levelClassName;

  switch (level) {
    case 0:
      containerClassName = 'HSMContainer activityc';
      nextContainerClassName = 'HSMContainer comptask';
      levelClassName = 'level0';
      break;
    case 1:
      containerClassName = 'HSMContainer comptask';
      nextContainerClassName = 'HSMContainer task';
      levelClassName = 'level1';
      break;
    case 2:
      containerClassName = 'HSMContainer task';
      nextContainerClassName = 'HSMContainer compskill';
      levelClassName = 'level2';
      break;
    case 3:
      containerClassName = 'HSMContainer compskill';
      nextContainerClassName = 'HSMContainer skill';
      levelClassName = 'level3';
      break;
    case 4:
      containerClassName = 'HSMContainer skill';
      levelClassName = 'level4';
      break;
  }

  if (stateAncestors.length === 1) {
    nextContainerClassName =
      nextContainerClassName + ' level' + (level + 1) + '-active';
  }

  if (stateAncestors.length === 1) {
    return (
      <div className={containerClassName}>
        <div className='flex-w100'>
          <StateBox {...stateAncestors[0]} hideTools={true} />
          <span className={'vertArrow ' + levelClassName}>{arrowImg}</span>
          <div className={nextContainerClassName}>{hsm}</div>
        </div>
      </div>
    );
  }

  if (stateAncestors.length > 1) {
    return (
      <div className={containerClassName}>
        <div className='flex-w100'>
          <StateBox {...stateAncestors[0]} hideTools={true} />
          <span className={'vertArrow ' + levelClassName}>{arrowImg}</span>
          <HSMContainer
            stateAncestors={stateAncestors.slice(1)}
            level={level + 1}
            hsm={hsm}
          />
        </div>
      </div>
    );
  }
};

export type LegendProps = {
  active: boolean;
  setActive: React.Dispatch<React.SetStateAction<boolean>>;
};

export const Legend = ({ active, setActive }: LegendProps) => {
  if (active) {
    return (
      <div className='legend-container'>
        <div className='legend'>
          <div className='legend-activity'>Activity</div>
          <div className='legend-comptask'>Composite task</div>
          <div className='legend-task'>Task</div>
          <div className='legend-compskill'>Composite skill</div>
          <div className='legend-skill'>Skill</div>
          <button
            className='btn btn-warning'
            onClick={() => setActive(!active)}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              viewBox='-2 -2 24 24'
              width='75%'
              fill='currentColor'
            >
              <path d='M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z'></path>
              <path d='M11.414 10l2.829 2.828a1 1 0 0 1-1.415 1.415L10 11.414l-2.828 2.829a1 1 0 1 1-1.415-1.415L8.586 10 5.757 7.172a1 1 0 0 1 1.415-1.415L10 8.586l2.828-2.829a1 1 0 0 1 1.415 1.415L11.414 10z'></path>
            </svg>
          </button>
        </div>
      </div>
    );
  } else {
    return (
      <div className='legend-container'>
        <button className='btn btn-warning' onClick={() => setActive(!active)}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='-2 -2 24 24'
            width='75%'
            fill='currentColor'
          >
            <path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-10a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'></path>
          </svg>
        </button>
      </div>
    );
  }
};

export type ToolBarProps = {
  children: JSX.Element | JSX.Element[];
};

export const ToolBar = ({ children }: ToolBarProps) => {
  return (
    <div className='toolbar'>
      <div className='me-auto'>{children}</div>
      {/* <div className='ms-auto toolbar-end'> */}
      {/* <Legend/> */}
      {/* </div> */}
    </div>
  );
};

type TransitionProps = {
  type: TRANSITION_TYPE;
  orientation: TRANSITION_ORIENTATION;
  adding: boolean; // whether or not the transition displays an add state button
  predId: number;
  nextUID: () => number;
  crumbIds: number[];
  setCrumbIds: React.Dispatch<React.SetStateAction<number[]>>;
  setActivityProps: React.Dispatch<React.SetStateAction<StateBoxProps>>;
  setCursor: React.Dispatch<React.SetStateAction<string>>;
  setIsUnsavedChanges: React.Dispatch<React.SetStateAction<boolean>>;
};

const StateTransition = ({
  type,
  orientation,
  adding,
  predId,
  nextUID,
  crumbIds,
  setCrumbIds,
  setActivityProps,
  setCursor,
  setIsUnsavedChanges,
}: TransitionProps) => {
  const layersBelow = 4 - crumbIds.length;

  const AddIcon = () => {
    let svgProps = {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '-2 -2 24 24',
      width: '24',
      fill: 'currentColor',
      onClick: () => {
        setActivityProps((prevActivity) => {
          setIsUnsavedChanges(true);
          let newStateProps = getNewStateProps(
            nextUID,
            layersBelow,
            setActivityProps,
            crumbIds,
            setCrumbIds,
            setCursor
          );

          return {
            ...prevActivity,
            children: addStateUid(
              prevActivity,
              [...crumbIds],
              predId,
              newStateProps
            ),
          };
        });
      },
    };

    return (
      <svg {...svgProps}>
        <path d='M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm7 11v4a1 1 0 0 1-2 0v-4H5a1 1 0 0 1 0-2h4V5a1 1 0 1 1 2 0v4h4a1 1 0 0 1 0 2h-4z'></path>
      </svg>
    );
  };

  // TODO implement the following classes' styles in CSS
  const divClass =
    orientation === TRANSITION_ORIENTATION.DOWN ? 'transitionV' : 'transitionH';
  const arrowHeight = orientation === TRANSITION_ORIENTATION.DOWN ? 30 : 15;
  let arrowWidth = orientation === TRANSITION_ORIENTATION.DOWN ? 15 : 30;
  let imgSrc;

  switch (orientation) {
    case TRANSITION_ORIENTATION.DOWN:
      imgSrc = downArrow;
      break;
    case TRANSITION_ORIENTATION.LEFT:
      imgSrc = leftArrow;
      break;
    case TRANSITION_ORIENTATION.RIGHT:
      imgSrc = rightArrow;
      break;
  }

  if (
    orientation != TRANSITION_ORIENTATION.DOWN &&
    type != TRANSITION_TYPE.BETWEEN
  ) {
    // this transition is horizontal and either a head or tail transition
    arrowWidth *= 2;
  }
  const arrowImg = <img width={arrowWidth} height={arrowHeight} src={imgSrc} />;
  let transitionElts = [];

  if (
    !adding &&
    (type === TRANSITION_TYPE.BEFORE || type === TRANSITION_TYPE.AFTER)
  ) {
    return <td></td>;
  }

  if (!adding) {
    // the user is not in adding mode, so we just return a table
    // cell with a single arrow image in it
    return (
      <td>
        <div className={divClass}>{arrowImg}</div>
      </td>
    );
  }

  if (type != TRANSITION_TYPE.BEFORE) {
    // this transition should have an arrow before the plus button
    transitionElts.push(arrowImg);
  }

  transitionElts.push(<AddIcon />);

  if (type != TRANSITION_TYPE.AFTER) {
    // this transition should have an arrow after the plus button
    transitionElts.push(arrowImg);
  }

  return (
    <td>
      <div className={divClass}>{transitionElts}</div>
    </td>
  );
};

export type ReadOnlyHSMViewProps = {
  statesProps: StateBoxProps[];
  humanMode: boolean;
  info: any;
};

export const ReadOnlyHSMView = ({
  statesProps,
  humanMode,
  info,
}: ReadOnlyHSMViewProps) => {
  let stateElements = [];
  let cols = Math.min(1, statesProps.length);
  let rows = Math.ceil(statesProps.length / cols);
  let predId = -1; // initialize the predecessor ID to -1

  // cols columns for the states, cols-1 columns for the transitions,
  // and 1 column at beginning and end of each row
  let htmlCols = cols + (cols - 1) + 2;

  for (let i = 0; i < rows; i++) {
    // the orientation of the arrow AFTER this state
    // even-indexed rows flow to the right, while odd-indexed rows flow left
    let arrowHOrientation =
      i % 2 === 0 ? TRANSITION_ORIENTATION.RIGHT : TRANSITION_ORIENTATION.LEFT;

    // retrieve the states that go in the current row (i)
    let statesThisRow = statesProps.slice(
      i * cols,
      Math.min(statesProps.length, i * cols + cols)
    );
    let tdsThisRow = [];

    // determine what the first cell of the row should be (either empty or
    // contains a head or tail transition)
    if (i === 0) {
      tdsThisRow.push(<td></td>); // added this today
    } else {
      // the first element of any row (except the first row) should contain the tail transition only
      // if the row is at max capacity AND the row index is odd AND it is the final row in the table.
      // otherwise, the first cell is empty
      if (statesThisRow.length === cols && i % 2 === 1 && i === rows - 1) {
        // this row is at max capacity and odd-indexed.

        tdsThisRow.push(<td></td>); // added this today
      } else {
        // this row not at max capacity or its even-indexed, so first cell is empty

        tdsThisRow.push(<td></td>);
      }
    }

    for (let j = 0; j < statesThisRow.length; j++) {
      let stateProps = {
        // type: getStateTypeFromLayers(3 - crumbIds.length),
        viewOnlyMode: true,
        discussionButtons: false,
        editing: false,
        hideTools: true,
        humanMode: humanMode,
      };

      let td = (
        <td>
          <StateBox {...statesProps[i * cols + j]} {...stateProps} />
        </td>
      );

      tdsThisRow.push(td);
      predId = statesProps[i * cols + j].id;

      // each state (except the last of the row) gets a transition after it
      if (j < statesThisRow.length - 1) {
        // must draw an in-between transition
        const currentPredId = predId;
        let transitionProps: TransitionProps = {
          type: TRANSITION_TYPE.BETWEEN,
          orientation: arrowHOrientation,
          adding: false,
          predId: statesProps[i * cols + j].uid,
          nextUID: () => -1,
          crumbIds: [],
          setCrumbIds: () => {},
          setActivityProps: () => {},
          setCursor: () => {},
          setIsUnsavedChanges: () => {},
        };

        tdsThisRow.push(<StateTransition {...transitionProps} />);
      }
    }

    // if this row is not at max capacity, add the tail transition and empty cells
    // for the "ghost" states that should be there. this keeps the table aligned properly

    if (statesThisRow.length < cols) {
      // not at max capacity. add tail transition and empty cells. also add empty end cell
      // we know the end cell is empty because the tail transition occurs earlier in the row
      const currentPredId = predId;
      let numEmptyCells = 2 * (cols - statesThisRow.length) - 1;
      tdsThisRow.push(<td></td>); // i added this today 2/20
      tdsThisRow.push(<td colSpan={numEmptyCells}></td>);
      tdsThisRow.push(<td></td>);
    } else {
      // this row is at max capacity.
      // if the final row at max capacity is even-indexed,
      // we let the end cell be the tail transition. otherwise, we leave the end cell empty.
      if (i % 2 == 0 && i === rows - 1) {
        const currentPredId = predId;

        tdsThisRow.push(<td></td>); // i added this today
      } else {
        // we leave the end cell empty for odd rows
        tdsThisRow.push(<td></td>);
      }
    }

    if (i % 2 === 1) {
      // reverse every other row to get the spiral state machine effect
      // however, we do not want to touch the begin and end cells.
      tdsThisRow = [
        tdsThisRow[0],
        ...tdsThisRow.slice(1, tdsThisRow.length - 1).reverse(),
        tdsThisRow[tdsThisRow.length - 1],
      ];
    }

    stateElements.push(<tr key={i}>{tdsThisRow}</tr>);

    const currentPredId = predId;
    let transitionProps: TransitionProps = {
      type: TRANSITION_TYPE.BETWEEN,
      orientation: TRANSITION_ORIENTATION.DOWN,
      adding: false,
      predId: currentPredId,
      nextUID: () => -1,
      crumbIds: [],
      setCrumbIds: () => {},
      setActivityProps: () => {},
      setCursor: () => {},
      setIsUnsavedChanges: () => {},
    };

    if (i % 2 == 0 && i < rows - 1) {
      // we need a down arrow in the column right before the end cell
      stateElements.push(
        <tr key={-i - 1}>
          <td colSpan={htmlCols - 2}></td>
          <StateTransition {...transitionProps} />
          <td></td>
        </tr>
      );
    } else if (i % 2 == 1 && i < rows - 1) {
      // we need a down arrow in the column right after the begin cell
      stateElements.push(
        <tr key={-i - 1}>
          <td></td>
          <StateTransition {...transitionProps} />
          <td colSpan={htmlCols - 2}></td>
        </tr>
      );
    }
  }

  // TODO rename to HSMView
  return (
    <div className='template'>
      <h3>
        Submitted by {info.author.name} ({info.author.occupation})
      </h3>
      <table className='HSMView'>
        <tbody>{stateElements}</tbody>
      </table>
    </div>
  );
};

export type HSMViewProps = {
  activityProps: StateBoxProps;
  setActivityProps: React.Dispatch<React.SetStateAction<StateBoxProps>>;
  crumbIds: number[];
  setCrumbIds: React.Dispatch<React.SetStateAction<number[]>>;
  setLayer: React.Dispatch<React.SetStateAction<string>>;
  discussionButtons: boolean;
  viewOnlyMode: boolean;
  editing: boolean;
  setCursor: React.Dispatch<React.SetStateAction<string>>;
  nextUID: () => number;
  setShowingCommentsFor: (id: number) => void;
  setShowingPapersFor: (id: number) => void;
  setIsUnsavedChanges: React.Dispatch<React.SetStateAction<boolean>>;
  isHumanMode: boolean;
};

export const HSMView = ({
  activityProps,
  setActivityProps,
  crumbIds,
  setCrumbIds,
  setLayer,
  discussionButtons,
  viewOnlyMode,
  editing,
  setCursor,
  nextUID,
  setShowingCommentsFor,
  setShowingPapersFor,
  setIsUnsavedChanges,
  isHumanMode,
}: HSMViewProps) => {
  let statesProps = getStatesCurrentLayer(activityProps, crumbIds);
  let stateElements = [];
  let cols = Math.min(1, statesProps.length);
  let rows = Math.ceil(statesProps.length / cols);
  let predId = -1; // initialize the predecessor ID to -1

  if (statesProps.length === 0) {
    return <h1 className='ms-auto me-auto'>Workflow coming soon</h1>;
  }

  // cols columns for the states, cols-1 columns for the transitions,
  // and 1 column at beginning and end of each row
  let htmlCols = cols + (cols - 1) + 2;

  for (let i = 0; i < rows; i++) {
    // the orientation of the arrow AFTER this state
    // even-indexed rows flow to the right, while odd-indexed rows flow left
    let arrowHOrientation =
      i % 2 === 0 ? TRANSITION_ORIENTATION.RIGHT : TRANSITION_ORIENTATION.LEFT;

    // retrieve the states that go in the current row (i)
    let statesThisRow = statesProps.slice(
      i * cols,
      Math.min(statesProps.length, i * cols + cols)
    );
    let tdsThisRow = [];

    predId = statesProps[i * cols].id;

    // determine what the first cell of the row should be (either empty or
    // contains a head or tail transition)
    if (i === 0) {
      // the first element of the first row is always the head transition
      let headTransitionProps: TransitionProps = {
        type: TRANSITION_TYPE.BEFORE,
        orientation: arrowHOrientation,
        adding: editing,
        predId: -1,
        nextUID: nextUID,
        crumbIds: crumbIds,
        setCrumbIds: setCrumbIds,
        setActivityProps: setActivityProps,
        setCursor: setCursor,
        setIsUnsavedChanges: setIsUnsavedChanges,
      };

      tdsThisRow.push(<StateTransition {...headTransitionProps} />);
    } else {
      // the first element of any row (except the first row) should contain the tail transition only
      // if the row is at max capacity AND the row index is odd AND it is the final row in the table.
      // otherwise, the first cell is empty
      if (statesThisRow.length === cols && i % 2 === 1 && i === rows - 1) {
        // this row is at max capacity and odd-indexed.

        let tailTransitionProps: TransitionProps = {
          type: TRANSITION_TYPE.AFTER,
          orientation: arrowHOrientation,
          adding: editing,
          predId: statesProps[i * cols].uid,
          nextUID: nextUID,
          crumbIds: crumbIds,
          setCrumbIds: setCrumbIds,
          setActivityProps: setActivityProps,
          setCursor: setCursor,
          setIsUnsavedChanges: setIsUnsavedChanges,
        };

        tdsThisRow.push(<StateTransition {...tailTransitionProps} />);
      } else {
        // this row not at max capacity or its even-indexed, so first cell is empty

        tdsThisRow.push(<td></td>);
      }
    }

    for (let j = 0; j < statesThisRow.length; j++) {
      // ensure all states are clickable except the bottom layer (skills)
      let onClickFunc =
        crumbIds.length === 4 || (isHumanMode && crumbIds.length === 2)
          ? () => {}
          : () => {
              setCrumbIds((prevCrumbIds) => [
                ...prevCrumbIds,
                statesProps[i * cols + j].id,
              ]);
              setLayer(statesProps[i * cols + j].children[0].uid);
              setCursor('auto');
            };

      let setCursorPointerFunc =
        crumbIds.length === 4 || (isHumanMode && crumbIds.length === 2)
          ? () => {}
          : () => {
              setCursor('pointer');
            };

      let stateProps = {
        // type: getStateTypeFromLayers(3 - crumbIds.length),
        viewOnlyMode: viewOnlyMode,
        setText: (txt) => {
          setActivityProps((prevActivity) => {
            setIsUnsavedChanges(true);
            return {
              ...prevActivity,
              children: updatePropertyOfState(
                activityProps,
                [...crumbIds],
                statesProps[i * cols + j].id,
                'text',
                txt
              ),
            };
          });
        },
        setPreconditions: (prec) => {
          setActivityProps((prevActivity) => {
            setIsUnsavedChanges(true);
            return {
              ...prevActivity,
              children: updatePropertyOfState(
                activityProps,
                [...crumbIds],
                statesProps[i * cols + j].id,
                'preconditions',
                prec
              ),
            };
          });
        },
        setPostconditions: (postc) => {
          setActivityProps((prevActivity) => {
            setIsUnsavedChanges(true);
            return {
              ...prevActivity,
              children: updatePropertyOfState(
                activityProps,
                [...crumbIds],
                statesProps[i * cols + j].id,
                'postconditions',
                postc
              ),
            };
          });
        },
        setOwnership: (owner) => {
          setActivityProps((prevActivity) => {
            setIsUnsavedChanges(true);
            return {
              ...prevActivity,
              children: updatePropertyOfState(
                activityProps,
                [...crumbIds],
                statesProps[i * cols + j].id,
                'ownership',
                owner
              ),
            };
          });
        },
        discussionButtons: discussionButtons,
        editing: editing,
        setEditing: (editing) => {
          setActivityProps((prevActivity) => {
            return {
              ...prevActivity,
              children: updatePropertyOfState(
                prevActivity,
                [...crumbIds],
                statesProps[i * cols + j].id,
                'editing',
                editing
              ),
            };
          });
        },
        deleteSelf: () => {
          setActivityProps((prevActivity) => {
            setIsUnsavedChanges(true);
            return {
              ...prevActivity,
              children: deleteStateUid(
                prevActivity,
                [...crumbIds],
                statesProps[i * cols + j].uid
              ),
            };
          });
        },
        showComments: () => setShowingCommentsFor(statesProps[i * cols + j].id),
        showPapers: () => setShowingPapersFor(statesProps[i * cols + j].id),
        onClick: onClickFunc,
        setCursorPointer: setCursorPointerFunc,
        setCursorAuto: () => setCursor('auto'),
        humanMode: isHumanMode,
      };

      let td = (
        <td>
          <StateBox {...statesProps[i * cols + j]} {...stateProps} />
        </td>
      );

      tdsThisRow.push(td);

      // each state (except the last of the row) gets a transition after it
      if (j < statesThisRow.length - 1) {
        // must draw an in-between transition
        const currentPredId = predId;
        let transitionProps: TransitionProps = {
          type: TRANSITION_TYPE.BETWEEN,
          orientation: arrowHOrientation,
          adding: editing,
          predId: statesProps[i * cols + j].uid,
          nextUID,
          crumbIds,
          setCrumbIds,
          setActivityProps,
          setCursor,
          setIsUnsavedChanges: setIsUnsavedChanges,
        };

        tdsThisRow.push(<StateTransition {...transitionProps} />);
      }
    }

    // if this row is not at max capacity, add the tail transition and empty cells
    // for the "ghost" states that should be there. this keeps the table aligned properly

    if (statesThisRow.length < cols) {
      // not at max capacity. add tail transition and empty cells. also add empty end cell
      // we know the end cell is empty because the tail transition occurs earlier in the row
      const currentPredId = statesProps[i * cols].id;
      let numEmptyCells = 2 * (cols - statesThisRow.length) - 1;
      let tailTransitionProps: TransitionProps = {
        type: TRANSITION_TYPE.AFTER,
        orientation: arrowHOrientation,
        adding: editing,
        predId: statesProps[i * cols].uid,
        nextUID: nextUID,
        crumbIds: crumbIds,
        setCrumbIds: setCrumbIds,
        setActivityProps: setActivityProps,
        setCursor: setCursor,
        setIsUnsavedChanges: setIsUnsavedChanges,
      };

      tdsThisRow.push(<StateTransition {...tailTransitionProps} />);
      tdsThisRow.push(<td colSpan={numEmptyCells}></td>);
      tdsThisRow.push(<td></td>);
    } else {
      // this row is at max capacity.
      // if the final row at max capacity is even-indexed,
      // we let the end cell be the tail transition. otherwise, we leave the end cell empty.
      if (i % 2 == 0 && i === rows - 1) {
        const currentPredId = statesProps[i * cols].id;
        let tailTransitionProps: TransitionProps = {
          type: TRANSITION_TYPE.AFTER,
          orientation: arrowHOrientation,
          adding: editing,
          predId: statesProps[i * cols].uid,
          nextUID: nextUID,
          crumbIds: crumbIds,
          setCrumbIds: setCrumbIds,
          setActivityProps: setActivityProps,
          setCursor: setCursor,
          setIsUnsavedChanges: setIsUnsavedChanges,
        };

        tdsThisRow.push(<StateTransition {...tailTransitionProps} />);
      } else {
        // we leave the end cell empty for odd rows
        tdsThisRow.push(<td></td>);
      }
    }

    if (i % 2 === 1) {
      // reverse every other row to get the spiral state machine effect
      // however, we do not want to touch the begin and end cells.
      tdsThisRow = [
        tdsThisRow[0],
        ...tdsThisRow.slice(1, tdsThisRow.length - 1).reverse(),
        tdsThisRow[tdsThisRow.length - 1],
      ];
    }

    stateElements.push(<tr key={i}>{tdsThisRow}</tr>);

    const currentPredId = predId;
    let transitionProps: TransitionProps = {
      type: TRANSITION_TYPE.BETWEEN,
      orientation: TRANSITION_ORIENTATION.DOWN,
      adding: editing,
      predId: statesProps[i * cols].uid,
      nextUID,
      crumbIds,
      setCrumbIds,
      setActivityProps,
      setCursor,
      setIsUnsavedChanges: setIsUnsavedChanges,
    };

    if (i % 2 == 0 && i < rows - 1) {
      // we need a down arrow in the column right before the end cell
      stateElements.push(
        <tr key={-i - 1}>
          <td colSpan={htmlCols - 2}></td>
          <StateTransition {...transitionProps} />
          <td></td>
        </tr>
      );
    } else if (i % 2 == 1 && i < rows - 1) {
      // we need a down arrow in the column right after the begin cell
      stateElements.push(
        <tr key={-i - 1}>
          <td></td>
          <StateTransition {...transitionProps} />
          <td colSpan={htmlCols - 2}></td>
        </tr>
      );
    }
  }

  // TODO rename to HSMView
  return (
    <table className='HSMView'>
      <tbody>{stateElements}</tbody>
    </table>
  );
};

export type TitleInputProps = {
  title: string;
  setTitle: (x: string) => void;
  setIsUnsavedChanges: React.Dispatch<React.SetStateAction<boolean>>;
};

export const TitleInput = ({
  title,
  setTitle,
  setIsUnsavedChanges,
}: TitleInputProps) => {
  function onTitleChange(e) {
    if (e.target.value !== title) {
      setTitle(e.target.value);
      setIsUnsavedChanges(true);
    }
  }

  function onBlur(e) {
    if (title === '') {
      setTitle('Untitled workflow');
    }
  }

  return (
    <div className='input-group mb-3'>
      <div className='input-group-prepend'>
        <span className='input-group-text' id='inputGroup-sizing-default'>
          Workflow title
        </span>
      </div>
      <input
        type='text'
        placeholder='Untitled workflow'
        className='title-input'
        aria-label='Workflow title'
        aria-describedby='basic-addon2'
        value={title}
        onChange={(e) => onTitleChange(e)}
        onBlur={(e) => onBlur(e)}
      />
    </div>
  );
};

export enum RENDERER_MODE {
  EDIT,
  VIEW,
}

export type HSMRendererProps = {
  userContext: UserContext;
  activityId: string;
  activityProps: StateBoxProps;
  setActivityProps: React.Dispatch<React.SetStateAction<StateBoxProps>>;
  // humanActivityProps: StateBoxProps;
  // setHumanActivityProps : React.Dispatch<React.SetStateAction<StateBoxProps>>;
  showingCommentsFor: number;
  setShowingCommentsFor: React.Dispatch<React.SetStateAction<number>>;
  showingPapersFor: number;
  setShowingPapersFor: React.Dispatch<React.SetStateAction<number>>;
  crumbIds: number[];
  setCrumbIds: React.Dispatch<React.SetStateAction<number[]>>;
  setLayer: React.Dispatch<React.SetStateAction<string>>;
  setCursor: React.Dispatch<React.SetStateAction<string>>;
  toolbar: React.ReactElement<ToolBarProps>;
  children: React.ReactElement<HSMViewProps>[];
  editing: boolean;
  inEditMode?: boolean;
  setIsUnsavedChanges?: React.Dispatch<React.SetStateAction<boolean>>;
  isHumanMode: boolean;
  center: () => JSX.Element;
};

export const HSMRenderer = ({
  userContext,
  activityId,
  activityProps,
  setActivityProps,
  // humanActivityProps,
  // setHumanActivityProps,
  showingCommentsFor,
  setShowingCommentsFor,
  showingPapersFor,
  setShowingPapersFor,
  crumbIds,
  setCrumbIds,
  setLayer,
  setCursor,
  toolbar,
  children,
  editing,
  inEditMode = false,
  setIsUnsavedChanges,
  isHumanMode,
  center,
}: HSMRendererProps) => {
  const setCursorPointer = () => {
    setCursor('pointer');
  };

  const setCursorAuto = () => {
    setCursor('auto');
  };

  const [legendActive, setLegendActive] = useState(false);

  const updateEndpoint = editing
    ? `http://34.74.45.28:8080/hsm_edit/update/`
    : isHumanMode
    ? `http://34.74.45.28:8080/hsm_view_human/update/`
    : `http://34.74.45.28:8080/hsm_view/update/`;
  let commentsSidebar = null;

  if (showingCommentsFor === -1) {
    commentsSidebar = null;
  } else {
    // close the comment or papers sidebars if the active comment is no longer in the active layer
    let propsOfActiveCommentState = getPropsOfState(
      activityProps,
      crumbIds,
      showingCommentsFor
    );

    if (!propsOfActiveCommentState) {
      setShowingCommentsFor(-1);
    } else {
      let commentsSidebarProps: CommentsSidebarProps = {
        stateProps: getPropsOfState(
          activityProps,
          crumbIds,
          showingCommentsFor
        ),
        addComment: (commentText: string) => {
          let commentProps: CommentProps = {
            author: userContext.name,
            occupation: userContext.occupation,
            text: commentText,
          };
          let newActivityProps = {
            ...activityProps,
            children: addComment(
              activityProps,
              crumbIds,
              showingCommentsFor,
              commentProps
            ),
          };
          fetch(updateEndpoint + activityId, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(newActivityProps),
          }).then((res) => {
            if (res.ok) {
              setActivityProps(newActivityProps);
            }
          });
        },
        hideComments: () => setShowingCommentsFor(-1),
        children: getPropsOfState(activityProps, crumbIds, showingCommentsFor)
          .comments,
      };

      commentsSidebar = <CommentsSidebar {...commentsSidebarProps} />;
    }
  }

  let papersSidebar = null;

  if (showingPapersFor === -1) {
    papersSidebar = null;
  } else {
    // close the papers sidebars if the active comment is no longer in the active layer
    let propsOfActivePaperState = getPropsOfState(
      activityProps,
      crumbIds,
      showingPapersFor
    );

    if (!propsOfActivePaperState) {
      setShowingPapersFor(-1);
    } else {
      let papersProps: PapersSidebarProps = {
        stateProps: getPropsOfState(activityProps, crumbIds, showingPapersFor),
        addPaper: (
          paperTitle: string,
          paperUrl: string,
          modelInfo: string = ''
        ) => {
          let paperProps: PaperProps = {
            title: paperTitle,
            author: userContext.name,
            url: paperUrl,
            modelInfo: modelInfo,
          };
          let newActivityProps = {
            ...activityProps,
            children: addPaper(
              activityProps,
              crumbIds,
              showingPapersFor,
              paperProps
            ),
          };
          fetch(updateEndpoint + activityId, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(newActivityProps),
          }).then((res) => {
            if (res.ok) {
              setActivityProps(newActivityProps);
            }
          });
        },
        hidePapers: () => setShowingPapersFor(-1),
        children: getPropsOfState(activityProps, crumbIds, showingPapersFor)
          .papers,
      };

      papersSidebar = <PapersSidebar {...papersProps} />;
    }
  }

  // initialize the breadcrumb navigation bar props
  const bcNavProps: BCNavProps = {
    crumbIds: crumbIds,
    setCrumbIds: setCrumbIds,
    setLayer: setLayer,
    activityProps: activityProps,
    onMouseEnterCrumb: setCursorPointer,
    onMouseLeaveCrumb: setCursorAuto,
  };

  if (crumbIds.length === 0) {
    // there is no parent state since the app is still initializing
    return null;
  }

  function handleTitleChange(newTitle: string) {
    setActivityProps(updateTitleOfActivity(activityProps, newTitle));
  }

  // initialize the title input props
  const titleInputProps: TitleInputProps = {
    title: activityProps.text,
    setTitle: handleTitleChange,
    setIsUnsavedChanges: setIsUnsavedChanges,
  };

  let i = 1;
  let ancestorProps = [{ type: 'activity', text: activityProps.text }];

  while (i < crumbIds.length) {
    ancestorProps.push(
      getPropsOfState(activityProps, crumbIds.slice(0, i), crumbIds[i])
    );
    i++;
  }

  const arrowImg = <img width={30} height={15} src={rightArrow} />;

  // TODO rename to hsmrenderer
  return (
    <div className='HSMRenderer'>
      {center()}
      <BCNav {...bcNavProps} />
      {toolbar}
      {inEditMode && <TitleInput {...titleInputProps} />}
      {children.map((child, idx) => (
        <div className='HSMContainerRoot'>
          {/* {idx === 0 && ancestorProps.map((prop) => (
              <span className='flex'>
                <StateBox {...prop} hideTools={true} />
                <span className='vertArrow'>{arrowImg}</span>
              </span>
              )
            )} */}
          {idx === 0 && (
            <HSMContainer
              stateAncestors={ancestorProps}
              level={0}
              hsm={child}
            />
          )}
          {idx !== 0 && child}
        </div>
      ))}
      {/* <div className='HSMContainer'>
          {ancestorProps.map((prop) => <StateBox {...prop} hideTools={true}/>)}
          {children}
        </div> */}
      <Legend active={legendActive} setActive={setLegendActive} />
      {commentsSidebar}
      {papersSidebar}
    </div>
  );
};

export default HSMRenderer;
